<template>
  <!-- 发票查询 -->
  <div class="page-container" id="ebOrderContainer">
    <el-form
        :model="searchData"
        ref="ruleFormRef"
        class="form-panel"
        label-position="top"
        :validateOnRuleChange="false"
    >
      <el-row class="content-panel border-radius">
        <el-row :gutter="10" id="search">
          <el-col :span="6">
            <el-form-item label="订单号">
              <el-input
                  size="mini"
                  v-model="searchData.orderNoLike"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="开票抬头">
              <el-input
                size="mini"
                v-model="searchData.invoiceTitleName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="客户编号">
              <el-input
                size="mini"
                v-model="searchData.custBizNo"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="提单号">
              <el-input
                size="mini"
                v-model="searchData.mblNoLike"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col :span="16">
                <el-form-item label="大船船名/航次">
                  <el-associate
                    ref="vesselAssociate"
                    style="width: 100%"
                    :columns="associate_columns_vessel"
                    :query-method="associate_queryMethod_vessel"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    label-prop="vesselName"
                    value-prop="vesselId"
                    placeholder=""
                    v-model="searchData.vesselName"
                    :title="searchData.vesselName"
                    size="mini"
                    name="vesselName"
                    @change="onChangeVessel"
                    case="upper"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <label slot="label" class="label_no"></label>
                  <el-input
                    size="mini"
                    v-model="searchData.voyage">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col :span="12">
                <el-form-item label="开航日期从/开航日期到">
                  <el-date-picker
                    v-model="searchData.etdStart"
                    align="right"
                    type="date"
                    style="width: 100%"
                    size="mini"
                    placeholder=""
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <label slot="label" class="label_no"></label>
                  <el-date-picker
                    v-model="searchData.etdEnd"
                    align="right"
                    type="date"
                    style="width: 100%"
                    size="mini"
                    placeholder=""
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col :span="12">
                <el-form-item label="起运港/目的港">
                  <el-associate
                    style="width: 100%"
                    :columns="associate_columns_po"
                    :query-method="associate_queryMethod_po"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    label-prop="portNameEn"
                    value-prop="mdPortId"
                    placeholder=""
                    v-model="searchData.polId"
                    size="mini"
                    case="upper"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <label slot="label" class="label_no"></label>
                  <el-associate
                    style="width: 100%"
                    :columns="associate_columns_po"
                    :query-method="associate_queryMethod_po"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    label-prop="portNameEn"
                    value-prop="mdPortId"
                    placeholder=""
                    v-model="searchData.podId"
                    size="mini"
                    case="upper"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col :span="12">
                <el-form-item label="箱量/对账单号">
                  <el-input
                    size="mini"
                    v-model="searchData.ctnNum">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <label slot="label" class="label_no"></label>
                  <el-input
                    size="mini"
                    v-model="searchData.compNo">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col :span="12">
                <el-form-item label="增值税发票号/币种">
                  <el-input
                    size="mini"
                    v-model="searchData.invoiceNoLike">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <label slot="label" class="label_no"></label>
                  <el-select
                    class="length_input"
                    size="mini"
                    v-model="searchData.settleCurrencyCode"
                    placeholder="请选择"
                    ref="settleCurrencyCode"
                  >
                    <el-option
                      v-for="item in dict.MD_CODE_DICT$MD_CURRENCY"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col :span="12">
                <el-form-item label="开票日期从/开票日期到">
                  <el-date-picker
                    v-model="searchData.invoiceDateStart"
                    align="right"
                    type="date"
                    style="width: 100%"
                    size="mini"
                    placeholder=""
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <label slot="label" class="label_no"></label>
                  <el-date-picker
                    v-model="searchData.invoiceDateEnd"
                    align="right"
                    type="date"
                    style="width: 100%"
                    size="mini"
                    placeholder=""
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col :span="12">
                <el-form-item label="是否核销/是否开票">
                  <el-select
                    class="length_input"
                    size="mini"
                    v-model="searchData.allocationStatus"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="item in allocationStatusList"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <label slot="label" class="label_no"></label>
                  <el-select
                    class="length_input"
                    size="mini"
                    v-model="searchData.invoiceStatus"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="item in allocationStatusList"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="结算公司"
            >
              <el-associate
                style="width: 100%"
                :columns="associate_columns_csOffice"
                :query-method="associate_queryMethod_csOffice"
                class="input_length"
                clearable
                multiple="true"
                :query-length="0"
                label-prop="corpNameCn"
                value-prop="sysCorpId"
                placeholder=""
                :displayInit="settleOfficeNames"
                v-model="searchData.settleOffices"
                :title="searchData.settleOffices"
                size="mini"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
           <el-col :span="3" class="advanced-query-btns">
             <div class="in-the-right flex-position">
                <el-button class="el-button-search" type="primary" size="small" plain @click="queryForm">{{ $t('button.query') }}</el-button>
                <el-button type="primary" size="small" plain @click="excelInvoice">清单导出</el-button>
                <el-button type="primary" size="small" plain @click="resetForm">{{ $t('button.reset') }}</el-button>
            </div>
          </el-col>
        </el-row>
        <!-- 表格-start -->
        <el-row style="margin-top: 5px">
          <hot-table
              ref="ebOrderTableRef"
              :data-source="bcInvoiceTableDataSource"
              :settings="bcInvoiceTableSettings"
              col-settings-key="bcInvoice"
              @rowDblclick="bcInvoiceRowClick"
          >
            <hot-column
                :has-tip="true"
                title="订单号"
                data="orderNo"
                width="150"
            >
            </hot-column>
            <hot-column
                :has-tip="true"
                title="开票抬头"
                data="invoiceTitleNmae"
                width="150"
            >
            </hot-column>
            <hot-column
                :has-tip="true"
                title="币种"
                data="settleCurrencyCode"
                dictName="MD_CODE_BC_INVOICE_TYPE"
                width="50"
            >
            </hot-column>
            <hot-column
                :has-tip="true"
                title="金额"
                data="settleAmount"
                width="60"
            >
            </hot-column>
            <hot-column
              :has-tip="true"
              title="客户编号"
              data="custBizNo"
              width="150"
            >
            </hot-column>
            <hot-column
                :has-tip="true"
                title="客户操作员"
                data="opName"
                width="150"
            >
            </hot-column>
            <hot-column
              :has-tip="true"
              title="提单号"
              data="mblNo"
              width="150"
            >
            </hot-column>
            <hot-column
              :has-tip="true"
              title="船名"
              data="vesselName"
              width="150"
            >
            </hot-column>
            <hot-column
              :has-tip="true"
              title="航次"
              data="voyage"
              width="150"
            >
            </hot-column>
            <hot-column
              :has-tip="true"
              title="开航日"
              date-format="YYYY-MM-DD"
              data="etd"
              width="150"
            >
            </hot-column>
            <hot-column
              :has-tip="true"
              title="箱型箱量"
              data="ctnNum"
              width="150"
            >
            </hot-column>
            <hot-column
              :has-tip="true"
              title="目的港"
              data="podName"
              width="150"
            >
            </hot-column>
            <hot-column
              :has-tip="true"
              title="开票日期"
              data="invoiceDate"
              date-format="YYYY-MM-DD"
              width="150"
            >
            </hot-column>
            <hot-column
              :has-tip="true"
              title="增值税发票号"
              data="invoiceNo"
              width="150"
            >
            </hot-column>
            <hot-column
              :has-tip="true"
              title="所属组织"
              data="settleOfficeName"
              width="150"
            >
            </hot-column>
          </hot-table>
          <div class="pg_div">
            <el-pagination
              :current-page="pageConfig.currentPage"
              :layout="pageConfig.layout"
              :page-size="pageConfig.pageSize"
              :page-sizes="pageConfig.pageSizes"
              :total="pageConfig.total"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            />
          </div>
        </el-row>
        <!-- 分页start -->

        <!-- 分页end -->
        <!-- 表格-end -->
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { queryWebInvoice } from "@/api/queryMainSystem";
import {queryDictRows, queryInvoiceType, queryPoInfo, queryVoyageInfo} from "@/api/commonService";
import columnLinkRenderer from "../../components/CustomRenderer/columnLinkRenderer";
import sysCorpCust from "@/api/sysCorpCust";
import {downloadExcel,downloadExcel2} from "@/utils/downloadExcel";
import { export_json_to_excel } from "@/vendor/Export2Excel";
import Xlsx from 'xlsx'

export default {
  name: "Bill",
  components: {
    columnLinkRenderer,
  },
  data() {
    return {
      /** 下拉列表数据集合 */
      list: [],
      associate_columns_csOffice: [
        {
          title: "代码",
          field: "sysCorpId",
        },
        // {
        //   title: "公司简称",
        //   field: "corpName",
        // },
        {
          title: "中文全称",
          field: "corpNameCn",
        },
      ],
      associate_columns_po: [
        {
          title: "英文名称",
          field: "portNameEn",
        },
        {
          title: "中文名称",
          field: "portNameCn",
        },
        {
          title: "国家代码",
          field: "countryCode",
        },
        {
          title: "海港代码",
          field: "portCode",
        },
      ],
      associate_columns_vessel: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
      ],
      dict:[],
      //日期设置
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      invoiceTypeList: [], //发票类型
      settleOfficeNames: [],
      allocationStatusList: [{value: "否", key: "N"},{value: "是", key: "Y"}],
      searchData: {
        compNo:null,
        allocationStatus:"N",
        invoiceStatus:"N",
        polId: null,
        etdStart:null,
        etdEnd:null,
        mblNoLike: null,
        invoiceNoLike: null,
        issuedDateStart: null,
        issuedDateEnd: null,
        invoiceType: null,
        settleCustId: null,
        orderNo: null,
        invoiceTitleId: null,
        settleCurrencyCode: null,
        custBizNo: null,
        invoiceTitleName: null,
        vesselId: null,
        voyage: null,
        etdS: null,
        etde: null,
        invoiceDateStart: null,
        invoiceDateEnd: null,
        orderNoLike:null,
        ctnNum: null,
        podId: null,
        invoiceNo: null,
        settleOffice: null,
        settleOffices: []
      },
      // 分页
      pageConfig: {
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
        pageSize: 20,
        pagerCount: 100,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100],
      },
      // 发票类型联想控件
      associate_columns_invoice: [
        {
          title: "开票类型",
          field: "invoiceTypeName",
        },
        {
          title: "税率",
          field: "taxRate",
        }
      ],
      // 表格数据
      bcInvoiceTableDataSource: [],
      // 表格设置
      bcInvoiceTableSettings: {
        collapsibleColumns: true,
        height: 420,
        stretchH: "all", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
      pageID: {},
    };
  },
  created() {
  },
  async mounted() {
    //默认为将所有结算公司勾选
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    let csCustId = userInfo.custId;
    if (csCustId==null){
      csCustId = 523;
    }
    let params = {
      page: 1,
      limit: 100,
      csCustId: csCustId,
    };
    sysCorpCust.getsysCorpCustCsOffice(params).then((res) => {
      if(res.data.data.length>0){
        res.data.data.forEach(item => {
          this.settleOfficeNames.push(item.corpNameCn);
          this.searchData.settleOffices.push(item.sysCorpId);
        });
      }
    });

    let dictCode = [];
    dictCode.push("MD_CODE_DICT$MD_CURRENCY");
    this.dict = await this.$getDataDictionary.getSelectList(dictCode.join(','));
    for(var key in this.dict){
      let dict = [];
      this.dict[key].forEach((item) => {
        let param = {};
        param.name = item.value;
        param.value = item.key;
        param.count = 0;
        dict.push(param);
      });
      let dicts = {};
      dicts[key] = dict;
      this.$hotTableUtils.registDict(dicts);
    }
    // 监听外层容器div宽度的变化，做表格自适应  77 tab到顶端距离，30按钮行 32表格头 30 分页
    this.bcInvoiceTableSettings.height = document.body.clientHeight - document.getElementById("search").offsetHeight-77-30-32-30;
  },
  watch: {
    screenWidth(val,oldVal){
      if (val < 961) {
        console.log('小于961px')
      } else {
        console.log('大于960px')
      }
    },
  },
  methods: {
    changeCsOffice(value, selectedRows) {
      // this.ebOrder.settleOfficeName = selectedRows.corpNameCn;
      // this.ebOrder.settleOffice = selectedRows.sysCorpId;
    },
    associate_queryMethod_csOffice({ keyword, pageSize, currentPage }) {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let csCustId = userInfo.custId;
      if (csCustId==null){
        csCustId = 523;
      }
      let params = {
        page: self.pageConfig.currentPage,
        limit: self.pageConfig.pageSize,
        csCustId: csCustId,
      };
      if (keyword !== "") {
        params.corpNameCn = keyword;
      }
      return new Promise((resolve) => {
        sysCorpCust.getsysCorpCustCsOffice(params).then((res) => {
          resolve({
            records: res.data.data,
            total: res.data.length,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    associate_queryMethod_vessel({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
        };
      } else {
        params = {
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.vesselName"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.voyage LIKE :voyage1 OR CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0)) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted2)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    associate_queryMethod_po({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          portType4: ["OP", "IP"],
          isDeleted5: "0",
          isActive: "1",
        };
      } else {
        params = {
          portNameEn0: "%" + keyword + "%",
          portNameCn1: "%" + keyword + "%",
          countryCode2: "%" + keyword + "%",
          portCode3: "%" + keyword + "%",
          portType4: ["OP", "IP"],
          isDeleted5: "0",
          isActive: "1",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdPort.portNameEn"],
        mainModelName: "CTS_ILPMdPort",
        tag: "CTS_ILP_es",
        where:
          "(((((CTS_ILPMdPort.portNameEn LIKE :portNameEn0 OR CTS_ILPMdPort.portNameCn LIKE :portNameCn1) OR CTS_ILPMdPort.countryCode LIKE :countryCode2) OR CTS_ILPMdPort.portCode LIKE :portCode3) AND CTS_ILPMdPort.portType IN( :portType4)) AND CTS_ILPMdPort.isDeleted = :isDeleted5)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdPort.mdPortId",
          "CTS_ILPMdPort.createOffice",
          "CTS_ILPMdPort.lastModifyOffice",
          "CTS_ILPMdPort.lastModifyOfficeName",
          "CTS_ILPMdPort.lastModifierId",
          "CTS_ILPMdPort.areaCode",
          "CTS_ILPMdPort.lineNameCn",
          "CTS_ILPMdPort.portNameEn",
          "CTS_ILPMdPort.principalGroupCode",
          "CTS_ILPMdPort.customsCode",
          "CTS_ILPMdPort.isActive",
          "CTS_ILPMdPort.createOfficeName",
          "CTS_ILPMdPort.creatorName",
          "CTS_ILPMdPort.lastModifierName",
          "CTS_ILPMdPort.appCode",
          "CTS_ILPMdPort.longitude",
          "CTS_ILPMdPort.creatorId",
          "CTS_ILPMdPort.recordVersion",
          "CTS_ILPMdPort.lastModifyTime",
          "CTS_ILPMdPort.portNameCn",
          "CTS_ILPMdPort.portCode",
          "CTS_ILPMdPort.createTime",
          "CTS_ILPMdPort.isDeleted",
          "CTS_ILPMdPort.iataCode",
          "CTS_ILPMdPort.latitude",
          "CTS_ILPMdPort.lineId",
          "CTS_ILPMdPort.countryName",
          "CTS_ILPMdPort.countryCode",
          "CTS_ILPMdPort.portType",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryPoInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    onChangeVessel(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      let record = this.$refs.vesselAssociate.list[this.$refs.vesselAssociate.hoverIndex];
      this.searchData.vesselName = record.vesselName;
      this.searchData.voyage = record.voyage;
      this.searchData.vesselId = record.vesselId;
    },
    bcInvoiceRowClick(val) {
      let row = val.record;
      // sessionStorage.setItem("webInvoice", JSON.stringify([row]));
      this.$router.push({
        name: 'orderInvoiceDetails',
        params: {
          mblNo: row.mblNo,
          goOrderId: row.goOrderId,
          bcPublicOrderId: row.bcPublicOrderId,
          type: "manage",
        },
      })
    },
    changeissuedDateTo() {
      let self = this;
      self.searchData.issuedDateEnd = new Date(self.searchData.issuedDateEnd.getTime() + 1000 * 24 * 3600 - 100);
    },
    //点击
    clickModule(e) {
    },
    // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      let self = this;
      self.queryStatusPage();
    },
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageConfig.currentPage = val;
      let self = this;
      self.queryStatusPage();
    },
    // 单击行事件
    rowClick(val) {
      let self = this;
      self.currentEbOrder = val.record;
    },
    // tab切换事件
    handleClick(tab, event) {
      let self = this;
      self.pageConfig.currentPage = 1;
      self.queryStatusPage();
    },
    queryStatusPage() {
      let self = this;
      self.queryForm();
    },
    //重置搜索框
    resetForm() {
      //默认为将所有结算公司勾选
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let csCustId = userInfo.custId;
      if (csCustId==null){
        csCustId = 523;
      }
      let params = {
        page: 1,
        limit: 100,
        csCustId: csCustId,
      };
      let settleOffices = [];
      sysCorpCust.getsysCorpCustCsOffice(params).then((res) => {
        if (res.success) {
          if(res.data.data.length>0){
            res.data.data.forEach(item => {
              settleOffices.push(item.sysCorpId);
            });
          }
          this.searchData = {
            compNo: null,
            allocationStatus: "N",
            invoiceStatus: "N",
            polId: null,
            etdStart: null,
            etdEnd: null,
            mblNoLike: null,
            invoiceNoLike: null,
            issuedDateStart: null,
            issuedDateEnd: null,
            invoiceType: null,
            settleCustId: null,
            orderNo: null,
            invoiceTitleId: null,
            settleCurrencyCode: null,
            custBizNo: null,
            invoiceTitleName: null,
            vesselId: null,
            voyage: null,
            etdS: null,
            etde: null,
            invoiceDateStart: null,
            invoiceDateEnd: null,
            orderNoLike: null,
            ctnNum: null,
            podId: null,
            invoiceNo: null,
            settleOffices: settleOffices,
          };
        }
      });
    },
    //查询
    queryForm() {
      let self = this;

      if(self.searchData.settleOffices.length === 0){
        self.$coreMethods.message("warning", "结算公司不能为空");
        return
      }
      if(!((self.searchData.invoiceDateStart!=null && self.searchData.invoiceDateEnd!=null  ) || (self.searchData.etdStart!=null && self.searchData.etdEnd!=null  ))){
        self.$coreMethods.message("warning", "开航日期或开票日期不能为空");
        return
      }
      if(self.searchData.invoiceDateStart!=null && self.searchData.invoiceDateEnd!=null && (new Date(self.searchData.invoiceDateEnd).getTime() - new Date(self.searchData.invoiceDateStart).getTime() > 7776000000) ){

        self.$coreMethods.message("warning", "开票日期不能大于三个月");
        return
      }

      if(self.searchData.etdStart!=null && self.searchData.etdEnd!=null && (new Date(self.searchData.etdEnd).getTime() - new Date(self.searchData.etdStart).getTime() > 7776000000) ){
        self.$coreMethods.message("warning", "开航日期不能大于三个月");
        return
      }
      if(self.searchData.orderNoLike!==null && self.searchData.orderNoLike!==undefined ){
        this.searchData.orderNoLike = this.searchData.orderNoLike.replaceAll(" ", "");
      }
      if(self.searchData.invoiceTitleName!==null && self.searchData.invoiceTitleName!==undefined ){
        this.searchData.invoiceTitleName = this.searchData.invoiceTitleName.replaceAll(" ", "");
      }
      if(self.searchData.custBizNo!==null && self.searchData.custBizNo!==undefined ){
        this.searchData.custBizNo = this.searchData.custBizNo.replaceAll(" ", "");
      }
      if(self.searchData.mblNoLike!==null && self.searchData.mblNoLike!==undefined ){
        this.searchData.mblNoLike = this.searchData.mblNoLike.replaceAll(" ", "");
      }
      if(self.searchData.voyage!==null && self.searchData.voyage!==undefined ){
        this.searchData.voyage = this.searchData.voyage.replaceAll(" ", "");
      }
      if(self.searchData.ctnNum!==null && self.searchData.ctnNum!==undefined ){
        this.searchData.ctnNum = this.searchData.ctnNum.replaceAll(" ", "");
      }
      if(self.searchData.compNo!==null && self.searchData.compNo!==undefined ){
        this.searchData.compNo = this.searchData.compNo.replaceAll(" ", "");
      }
      if(self.searchData.invoiceNoLike!==null && self.searchData.invoiceNoLike!==undefined ){
        this.searchData.invoiceNoLike = this.searchData.invoiceNoLike.replaceAll(" ", "");
      }
      self.queryButton = 2;

      let params = JSON.parse(JSON.stringify(self.searchData));

      let num = 0;
      for (let s in params) {
        if (params[s] !== null && params[s].length>0) {
          if(s === "orderNoLike" || s==="invoiceNoLike" || s==="ctnNum" || s==="mblNoLike"){
            params[s] = params[s]+"%";
          }
          num++;
        } else {
          delete params[s]
        }
      }

      if(JSON.parse(localStorage.getItem('userInfo')) && JSON.parse(localStorage.getItem('userInfo')).custId!=null){
        params.settleCustId = JSON.parse(localStorage.getItem('userInfo')).custId;
      }

      params.settleOffice = params.settleOffices[0];
      delete params.settleOffices;

      if (num === 0) {
        self.$coreMethods.message("warning", "至少输入一个查询条件");
      } else {
        params.currentPage = self.pageConfig.currentPage;
        params.pageSize = self.pageConfig.pageSize;
        queryWebInvoice(params).then((res) => {
          if (res.records) {
            self.bcInvoiceTableDataSource = res.records;
            if (self.bcInvoiceTableDataSource) {
              self.bcInvoiceTableDataSource.forEach((item) => {
                // item.custName = JSON.parse(localStorage.getItem('userInfo')).custName;
                item.issuedDate = self.$moment(item.issuedDate).format("yyyy-MM-DD HH:mm:ss");
                item.cancelledDate = self.$moment(item.cancelledDate).format("yyyy-MM-DD HH:mm:ss");
                item.frCommitDate = self.$moment(item.frCommitDate).format("yyyy-MM-DD HH:mm:ss");
              });
            }
            self.searchData.pageSize = res.totalPage;
            self.pageConfig.total = res.totalRecord;
            if (res.records.length === 0){
              self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
            }else {
              self.$coreMethods.message("success", "查询成功！");
            }
          }
        });
      }
    },
    excelInvoice(){
      var  selectData = []
        if(this.$refs.ebOrderTableRef.getSelections().length>0){
          selectData = this.$refs.ebOrderTableRef.getSelections()
        }else{
          if(this.bcInvoiceTableDataSource.length>0){
            selectData = this.bcInvoiceTableDataSource
          }
        }

      selectData.forEach((item) => {
          item.etd = this.$moment(item.etd).format("yyyy-MM-DD");
          item.invoiceDate = this.$moment(item.invoiceDate).format("yyyy-MM-DD");
       });


        //downloadExcel2(selectData,'webInvoice')
        //var  invoiceNos = []
        //for(var a in selectData){
        //  invoiceNos.push(selectData[a].invoiceNo)
        //}
        var tableCol =this.$refs.ebOrderTableRef.$children
        var str =''
        var head = ''
        for(var i=0; i<tableCol.length-2; i++){
          str+= tableCol[i].columnSettings.data
          head+= tableCol[i].columnSettings.title
          if(i!==tableCol.length-3){
            str+=','
            head+=','
          }
        }
       var strs = str.split(',');
       var heads = head.split(',');
       var data = selectData.map((a) => strs.map((b) => a[b]));
       var date = this.currentTime();
       var fileName = "webInvoice" + date;
       export_json_to_excel({
        header: heads,// 表头
        data: data, // 数据列表
        filename: fileName,// 保存文件名
      });

        //window.location.origin
        //var url = process.env.VUE_APP_BASE_API+'/web/daoService/excelExport/custom-sql/cts-web/CTS_ILP_WebExportInvoiceFreight/web'
        //let reqArgs = {
        //  invoiceNo: invoiceNos
        //}
        //if(invoiceNos.length>0){
        //  downloadExcel(reqArgs,str,url,'webInvoice')
        //}else{
        //  self.$coreMethods.message('warn',this.$t('message.unableToExport'))
        //}
    },
    currentTime() {
        var date = new Date();
        var year = date.getFullYear(); //月份从0~11，所以加一
        let month = date.getMonth();
        console.log("month",month);
        var dateArr = [
            date.getMonth() + 1,
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds(),
        ];
        //如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
        for (var i = 0; i < dateArr.length; i++) {
            if (dateArr[i] >= 1 && dateArr[i] <= 9) {
                dateArr[i] = "0" + dateArr[i];
            }
        }
        var strDate =
            year +
            "/" +
            dateArr[0] +
            "/" +
            dateArr[1] +
            " " +
            dateArr[2] +
            ":" +
            dateArr[3] +
            ":" +
            dateArr[4];
            //此处可以拿外部的变量接收  strDate:2022-05-01 13:25:30
           	//this.date = strDate;
        return strDate;
    },
    // 发票类型联想控件数据源
    associate_queryMethod_invoice({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
        };
      } else {
        params = {
          invoiceTypeName0: "%" + keyword + "%",
          invoiceTypeName1: "%" + keyword + "%",
          isDeleted2: "0",
        };
      }
      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdInvoiceType.taxRate"],
        mainModelName: "CTS_ILPMdInvoiceType",
        tag: "CTS_ILP_es",
        where:
            "((CTS_ILPMdInvoiceType.invoiceTypeName LIKE :invoiceTypeName0 OR CTS_ILPMdInvoiceType.invoiceTypeName LIKE :invoiceTypeName1) AND CTS_ILPMdInvoiceType.isDeleted = :isDeleted2)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdInvoiceType.createOffice",
          "CTS_ILPMdInvoiceType.createOfficeName",
          "CTS_ILPMdInvoiceType.createTime",
          "CTS_ILPMdInvoiceType.creatorName",
          "CTS_ILPMdInvoiceType.invoiceNoType",
          "CTS_ILPMdInvoiceType.invoiceTypeCode",
          "CTS_ILPMdInvoiceType.invoiceTypeName",
          "CTS_ILPMdInvoiceType.isActive",
          "CTS_ILPMdInvoiceType.isDeleted",
          "CTS_ILPMdInvoiceType.lastModifierId",
          "CTS_ILPMdInvoiceType.lastModifierName",
          "CTS_ILPMdInvoiceType.lastModifyOffice",
          "CTS_ILPMdInvoiceType.lastModifyOfficeName",
          "CTS_ILPMdInvoiceType.lastModifyTime",
          "CTS_ILPMdInvoiceType.mdInvoiceTypeId",
          "CTS_ILPMdInvoiceType.principalGroupCode",
          "CTS_ILPMdInvoiceType.recordVersion",
          "CTS_ILPMdInvoiceType.rpFlag",
          "CTS_ILPMdInvoiceType.settleOffice",
          "CTS_ILPMdInvoiceType.settleOfficeName",
          "CTS_ILPMdInvoiceType.taxRate",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryInvoiceType(data).then((res) => {
          console.log("queryInvoiceType", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
  },
};
</script>
<style scoped >
</style>
